export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6490.051d0cf8.jpg";